import { StarFilled } from "@ant-design/icons";
import { Layout, PageHeader, Space, Table, Button } from "antd";
import React, { useEffect, useState } from "react";
import { RatingBadge } from "../../components/Layout/RatingBadge";
import DriverService from "../../services/DriverService";
import { useSelector } from "react-redux";
import DriverDetail from "./DriverDetail";
import AddEditDriver from "./AddEditDelivery";

const { Content } = Layout;
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (_, { photo_url, name }) => (
      <div className="flex items-center">
        <img
          src={photo_url}
          alt="avatar"
          style={{
            width: 100,
            height: 100,
            objectFit: "cover",
            objectPosition: "top center",
            borderRadius: "50%",
          }}
        />
        <div className="ml-1">{name}</div>
      </div>
    ),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone No",
    dataIndex: "phone_number",
    key: "phone_number",
  },
  {
    title: "Emp ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Avg. Rating",
    key: "average_rating",
    dataIndex: "average_rating",
    render: (_, { average_rating }) => (
      <RatingBadge value={average_rating}>
        {average_rating || 0}
        <StarFilled className="ml-sm" />
      </RatingBadge>
    ),
  },
];

const ManageDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [defaultPage, setDefaultPage] = useState(1);
  const [isDetailsView, setIsDetailsView] = useState(false);
  const [isDriverAddView, setIsDriverAddView] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const adminRestaurant = useSelector((state) => state.admin);

  useEffect(() => {
    if (adminRestaurant) {
      getDriver(adminRestaurant);
    }
  }, [adminRestaurant]);

  const getDriver = async (id, page = 0) => {
    const data = await DriverService.getDrivers(id, page);
    setDrivers(data?.drivers);
    setTotalPage(data?.total);
  };

  return (
    <Content className="u-page-layout">
      <Space
        direction="vertical"
        style={{
          width: "100%",
          padding:"0px"
        }}
      >
        {isDetailsView && !isDriverAddView && (
          <>
            <DriverDetail driverId={selectedDriver} setIsDriverAddView={setIsDriverAddView} setIsDetailsView={setIsDetailsView}/>
          </>
        )}
        {isDriverAddView && (
          <>
            <AddEditDriver
              setIsDriverAddView={setIsDriverAddView}
              selectedDriver={selectedDriver}
              setSelectedDriver={setSelectedDriver}
              getDriver={getDriver}
            />
          </>
        )}

        {!isDriverAddView && !isDetailsView && (
          <>
            <PageHeader
            className="page-header"
              extra={[
                <Button
                  type="primary"
                  className="custom-btn"
                  onClick={() => setIsDriverAddView(true)}
                >
                  Add Driver
                </Button>,
              ]}
              title="Manage Drivers"
            />

            <div className=" text-left">
              <Table
              className="overflow-auto"
                columns={columns}
                dataSource={drivers}
                pagination={{
                  onChange: (page) => {
                    setDefaultPage(page);
                    getDriver(adminRestaurant, page - 1);
                  },
                  current: defaultPage,
                  pageSize: 10,
                  total: totalPage,
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      setSelectedDriver(record.id);
                      setIsDetailsView(true);
                    },
                  };
                }}
              />
            </div>
          </>
        )}
      </Space>
    </Content>
  );
};

export default ManageDrivers;
